import React from 'react';
import classNames from 'classnames';
import { Button, ButtonProps } from '../Button';
import { Icon, IconName } from '../Icon';
import styles from './IconLink.module.scss';

type IconLinkProps = Partial<ButtonProps> &
	React.AriaAttributes & {
		className?: string;
		icon: IconName;
		label: string;
		hideLabelOnMobile?: boolean;
	};

/**
 * Generic IconLink component, a link with a combination of an icon and text label. Used e.g. in header
 */
export const IconLink: React.FunctionComponent<IconLinkProps> = ({
	className,
	children,
	icon,
	label,
	hideLabelOnMobile,
	href,
	route,
	to,
	onClick,
	...props // For passing props inherited from React.AriaAttributes
}) => {
	return (
		<Button
			className={classNames(styles.link, className)}
			variant={'ghost'}
			to={to}
			route={route}
			href={href}
			aria-label={label}
			onClick={onClick}
			{...props}
			hasOnlyIcon={false}
		>
			<Icon name={icon} size={'md'} />
			<p className={classNames(styles.label, { ['u-hide-sm-max']: hideLabelOnMobile })}>{label}</p>
			{children}
		</Button>
	);
};
